import { Box, Button, Grid, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useSuperAdminSingleRol } from "../../context/SuperAdmin/SingleRoleContext";
import { Spinner } from "../../components/Loading/Spinner";
import SingleRoleDescription from "../../components/Table/Roles/SingleRoleDescription";
import EditRoleModal from "../../components/Table/Roles/EditRoleModal";
import TabsSingleRole from "../../components/Table/Roles/TabsSingleRole";
import { useAuthContext } from "../../hooks/Auth";


const SingleRolePage = () => {
  const { isLoading, role } = useSuperAdminSingleRol();
  const { canAccess } = useAuthContext();
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt:3,
        color:"#336B87"
      }}
    >
      {/* Boton para volver */}
      <Grid item>
          <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
            <ArrowBackOutlinedIcon />
            Volver
          </Button>
      </Grid>

      {isLoading ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
              <b>Rol</b> | {role.nombre}
            </Typography>
          </Grid>

          {/* Características del rol */}
          <Grid item>
            <SingleRoleDescription />
          </Grid>

          {/* Linea divisoria */}
          <Grid item>
            <Box
              sx={{ height: "1px", width: 1, border: "1px solid #005559" }}
            ></Box>
          </Grid>

          {/* Sección de Tabs */}
          <Grid item>
            <TabsSingleRole />
          </Grid>

          {/* Modal para editar fecha de inicio */}
          {canAccess("edit:role") && <Grid item>
            <EditRoleModal />
          </Grid>}
        </>
      )}
    </Grid>
  );
};

export default SingleRolePage;
